const API_URL = '/api/users';

class UsersService {
    async getAll() {
        const response = await fetch(API_URL, {
            headers: this.getHeaders()
        });
        if (!response.ok) throw new Error('Failed to fetch users');
        return await response.json();
    }

    async getById(id) {
        const response = await fetch(`${API_URL}/${id}`, {
            headers: this.getHeaders()
        });
        if (!response.ok) throw new Error('Failed to fetch user');
        return await response.json();
    }

    async create(userData) {
        const response = await fetch(API_URL, {
            method: 'POST',
            headers: this.getHeaders(),
            body: JSON.stringify(userData)
        });
        if (!response.ok) {
            const error = await response.json();
            throw new Error(error.message || 'Failed to create user');
        }
        return await response.json();
    }

    async update(id, userData) {
        const response = await fetch(`${API_URL}/${id}`, {
            method: 'PUT',
            headers: this.getHeaders(),
            body: JSON.stringify(userData)
        });
        if (!response.ok) {
            const error = await response.json();
            throw new Error(error.message || 'Failed to update user');
        }
        return await response.json();
    }

    async delete(id) {
        const response = await fetch(`${API_URL}/${id}`, {
            method: 'DELETE',
            headers: this.getHeaders()
        });
        if (!response.ok) throw new Error('Failed to delete user');
        return await response.json();
    }

    async getRoles() {
        const response = await fetch(`${API_URL}/roles`, {
            headers: this.getHeaders()
        });
        if (!response.ok) throw new Error('Failed to fetch roles');
        return await response.json();
    }

    getHeaders() {
        const token = localStorage.getItem('token');
        return {
            'Content-Type': 'application/json',
            ...(token && { 'Authorization': `Bearer ${token}` })
        };
    }
}

export default new UsersService();